import React from "react"
import { Controller, type Control } from "react-hook-form"

export interface FormInputProps {
  name: string
  control: Control
  label: string
  value: string
  checked?: boolean
  required?: boolean
  small?: boolean
}

const FormInputCheckbox = ({
  control,
  name,
  label,
  checked,
  required,
  small = false,
}: FormInputProps) => {
  const wrapperClass = `c-form__checkbox ${small ? "-small" : "-large"}`

  return (
    <div className={wrapperClass}>
      <Controller
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <input
                className="c-form__checkbox__input"
                type="checkbox"
                name={name}
                id={name + value}
                checked={checked}
                onChange={onChange}
                value={value}
                required={required}
              />
              <label
                className="c-form__checkbox__label"
                htmlFor={name + value}
                dangerouslySetInnerHTML={{ __html: label }}
              />
            </>
          )
        }}
        control={control}
      />
    </div>
  )
}

export default FormInputCheckbox
